import React from 'react';

export default function BreadcrumbChevron() {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.167 2.333L7.5 5.667L4.167 9" stroke="#535862" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
